import firebaseService from 'app/services/firebaseService';
import jwtService from 'app/services/jwtService';
import * as Actions from 'app/store/actions';
import * as UserActions from './user.actions';
import * as NewUserAction from 'app/store/actions/user/user.actions';
// import history from '@history';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const TOASTER_ACTION = 'TOASTER ACTION';

export function submitLogin(data) {
	return dispatch =>
		jwtService
			.signInWithEmailAndPassword(data)
			.then(data => {
				console.log('login.actions.js response data: ', data);
				if(!data.isError) {
					//debugger
					/*dispatch(toasterActions(true));*/
					dispatch(UserActions.setUserData(data.userDetails));
					dispatch(NewUserAction.setCurrentUser(data)); //start to get user's data
					// data.userDetails.position==='Admin' ?
					// 	history.push({pathname:'/dashboard/admin'})
					// :
					// 	history.push({pathname: '/dashboard/map'})
					// ;
					return dispatch({
						type: LOGIN_SUCCESS
					});

				} else {
					return dispatch({
						type: LOGIN_ERROR,
						payload: data.errors
					});
				}
				
			})
			.catch(error => {
				/*dispatch(toasterActions(false));*/
				return dispatch({
					type: LOGIN_ERROR,
					payload: error
				});
			});

}

/*export function toasterActions(data){
	return({
		type: TOASTER_ACTION,
		payload: data,
	})
}*/

export function submitLoginWithFireBase({ username, password }) {
	if (!firebaseService.auth) {
		console.warn("Firebase Service didn't initialize, check your configuration");

		return () => false;
	}

	return dispatch =>
		firebaseService.auth
			.signInWithEmailAndPassword(username, password)
			.then(() => {
				return dispatch({
					type: LOGIN_SUCCESS
				});
			})
			.catch(error => {
				console.info('error');
				const usernameErrorCodes = [
					'auth/email-already-in-use',
					'auth/invalid-email',
					'auth/operation-not-allowed',
					'auth/user-not-found',
					'auth/user-disabled'
				];
				const passwordErrorCodes = ['auth/weak-password', 'auth/wrong-password'];

				const response = {
					username: usernameErrorCodes.includes(error.code) ? error.message : null,
					password: passwordErrorCodes.includes(error.code) ? error.message : null
				};

				if (error.code === 'auth/invalid-api-key') {
					dispatch(Actions.showMessage({ message: error.message }));
				}

				return dispatch({
					type: LOGIN_ERROR,
					payload: response
				});
			});
}
